const legal = () => ({
  legal: {
    wordWrap: 'break-word',

    li: {
      listStylePosition: 'outside'
    }
  }
});
export default legal;
